module.exports = __webpack_public_path__ + "img/close.645ae470.svg";